import * as H from 'history';
import { string } from "prop-types";
import history from "../history";

export class Utils {    
    public static renderDate(dateObj: Date) {
        var dateStr = '';
        if (dateObj != null) {
            dateStr = dateObj.toString().substring(0, 10);
        }
        return dateStr;
    }

    public static GetRootUrl = () => {
        var protocol = window.location.protocol;
        var hostname = window.location.hostname;
        var port = window.location.port;
        var full = protocol + '//' + hostname + (port ? ':' + port : '');
        const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
        return full + baseUrl;
    }

    public static getQueryStringParams = (queryString: string, queryName: string) => {
        let params = new URLSearchParams(queryString);
        let queryVal = params.get(queryName);
        return queryVal;
    }

    public static getRandomNumber = () => {
        return Math.floor(Math.random() * 10000000) + 1;
    }
    public static GetTimeInUTC = (inputDate: Date) => {
        return new Date(Date.UTC(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate(), inputDate.getHours(), inputDate.getMinutes(), 0, 0));
    }
}

export function RenderCurrentYear() {
    return new Date().getFullYear();
}


export const GetRootUrl = () => {
    var full = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
    return full + baseUrl;
}

export function getCurrencyLabel(value: number) {
    return new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD' }).format(value);
}

export function getPercentageLabel(value: number) {
    return new Intl.NumberFormat('en-us', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

export function getFullDateTimeLabel(dateString: string) {
    var date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    }).format(date);
}

export function getDateTimeLabel(dateString: string) {
    var date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    }).format(date);
}
export function getDateLabel(dateString: string) {
    var date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    }).format(date);
}


export function emptyForm(form: HTMLFormElement): void {
    var inputs = Array.from(form.querySelectorAll("input, select, textarea"));
    inputs.forEach(x => {
        var inputType = x.getAttribute("type");
        if (inputType === "checkbox" || inputType === "radio") {
            (x as any).checked = false;
        } else {
            (x as any).value = "";
        }
    });
}

export function emptyField(form: HTMLFormElement, name: string): void {
    let element = form[name];
    var inputType = element.getAttribute("type");
    if (inputType === "checkbox" || inputType === "radio") {
        (element as any).checked = false;
    } else {
        (element as any).value = "";
    }
}

export function setFieldValue(form: HTMLFormElement, name: string, value: string): void {
    let element = form[name];
    (element as any).value = value;
}

export const CreateCookieMidnight = (name, value) => {
    // var exdate=new Date();
    // exdate.setHours(23);
    // exdate.setMinutes(59);
    // exdate.setSeconds(59);
    // var expires = "; expires="+exdate;
    // document.cookie = name+"="+value+expires+"; path=/";
    var expires = "";
	var date = new Date();
	var midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
	expires = "; expires=" + midnight.toUTCString();
	document.cookie = name + "=" + value + expires + "; path=/";
}

export const CreateCookie = (name, value, minutes) => {
    if (minutes) {
        var date = new Date();
        date.setTime(date.getTime()+(minutes*60*1000));
        var expires = "; expires="+date.toUTCString();
    } else {
        var expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

export const GetCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
